import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface ReportState {
  filters: {
    interview_names: string[]
    statuses: string[]
    emails: string[]
  }
  pageNumber: number
}

const initialFilters = {
  interview_names: [],
  statuses: [],
  emails: [],
}

const initialState: ReportState = {
  filters: initialFilters,
  pageNumber: 1,
}

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<ReportState["filters"]>>) => ({
      ...state,
      pageNumber: 1,
      filters: {
        ...state.filters,
        ...action.payload,
      },
    }),
    setPageNumber: (state, action: PayloadAction<ReportState["pageNumber"]>) => ({
      ...state,
      pageNumber: action.payload,
    }),
    resetFilters: (state) => ({
      ...state,
      filters: initialFilters,
    }),
    resetPageNumber: (state) => ({
      ...state,
      pageNumber: 1,
    }),
  },
})

export const { setFilters, setPageNumber, resetFilters, resetPageNumber } = reportSlice.actions

export default reportSlice.reducer
